
<style lang="less">
    @import "../../style/common.less";

	.ivu-tree-title{
		color: black!important;
	}
</style>

<template>
    <div class="iot-vue-container">
        <div class="vue-main">
            <div class="iot-form">
                <Form ref="formForm" :model="formInfo" :rules="ruleValidate">
                    <div class="flex-div">
                        <div class="flex-div-child">
                            <FormItem label="角色名" prop="roleName">
                                <Input v-model="formInfo.roleName"  :disabled="editFlag"></Input>
                            </FormItem>
                            <!--<FormItem label="状态" prop="plantStatus">-->
                                <!--<Select v-model="formInfo.plantStatus">-->
                                    <!--<Option  v-for="option in statusArr" :key="option.codeVal"  v-bind:value="option.codeVal">-->
                                        <!--{{option.codeName}}-->
                                    <!--</Option>-->
                                <!--</Select>-->
                                <!--&lt;!&ndash;<el-select v-model="formInfo.plantStatus" class="scada-el-select">-->
                                    <!--<el-option  v-for="option in statusArr" :key="option.codeVal" :label="option.codeName" :value="option.codeVal">-->
                                    <!--</el-option>-->
                                <!--</el-select> &ndash;&gt;-->
                            <!--</FormItem>-->
                        </div>
                        <div class="flex-div-child">
                            <FormItem label="角色菜单" >
                            </FormItem>
                            <div >
                                <Tree v-bind:data="menuList"  show-checkbox @on-check-change="onCheckChange"></Tree>
                            </div>
                        </div>
                    </div>
                    <FormItem class="search-div margin-top-10">
						<Button type="primary" @click="submitForm('formForm')" class="button button-glow button-rounded button-action" v-loading.fullscreen.lock="fullscreenLoading"><i class="fa fa-save"></i>&nbsp;&nbsp;提交</Button>
						<Button type="ghost" @click="resetForm('formForm')" class="button button-glow button-rounded button-highlight-flat"><i class="fa fa-close"></i>&nbsp;&nbsp;重置</Button>
						<Button type="ghost" @click="backToList" class="button button-glow button-rounded button-border button-highlight"><i class="fa fa-clos
						e"></i>&nbsp;&nbsp;返回</Button>
                    </FormItem>
                </Form>
            </div>
        </div>
    </div>
</template>



<script>
    import config from '@/config/config.js';
	import {mapActions} from "vuex";
    export default {
        data() {
            return {
                pageTitle: '角色新增',
                fullscreenLoading: false,
                sysCfg: config,
                editId: '',
                editFlag: false,
                formInfo: {},
                listRouter: 'rolelist',
                ruleValidate: {
                    roleName: [{
                        required: true,
                        message: '请输入角色名',
                        trigger: 'blur'
                    }],
                    plantStatus: [{
                        required: true,
                        message: '请选择状态',
                        trigger: 'change'
                    }],
                },
                statusArr:[],
                menuList:[],
                menus:[],
                defaultList:[],
                parentsObj:[],// 父菜单集合
                hasSel:false,
                menusObj:{},
            };
        },
        methods: {
			...mapActions("tab", ["reflush"]),
            init() {
                var _this = this;
                this.editId = this.$route.params.id;
                if (this.editId) {
                    //获取对象详细信息
                    this.getDetailInfo(this.editId);
                    this.editFlag = true;
                    this.pageTitle = '角色编辑';
                }else{
                    this.initMenuList();
                }
                // 获取配置项
                this.$job.getConfig(_this, _this.$config.cfgType['status'], function(res) {
                    _this.statusArr = res;
                });
            },
            // 获取详细信息
            getDetailInfo(id) {
                var _this = this;
                var url = _this.$api.role.list + '/' + id;
                _this.$httpUtil.ajaxGet(this, url, {}, function(response) {
                    _this.formInfo = response.data.data;
                    _this.defaultList  = _this.formInfo.menuIds;
                    _this.initMenuList();
                });
            },
            // 表单提交
            submitForm(formName) {
                var _this = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var url = this.$api.role.list;
						_this.formInfo.plantStatus='01';
                        // 提交判断
                        // if (_this.menus.length===0) {
                        //     _this.$util.error("请选择角色菜单");
                        // } else {
                            _this.formInfo.menuIds = _this.menus;
                            _this.$service.submitForm(_this, url, _this.listRouter);
                        // }
                    }
                });
            },
            // 返回列表
            backToList() {
                this.fullscreenLoading = false;
                var _this = this;
                this.$router.push({
                    name: _this.listRouter
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.init();
            },
            // 菜单选择
            onCheckChange(val) {
                var _this = this;
                this.menusObj = {};
                val.forEach((item) => {
                    _this.menusObj[item.id] = 1;
					var firstPId = item.parentId;
					_this.menusObj[firstPId] = 1;
					// if(item.level == '1' ){
					// 	var firstPId = item.parentId;
					// 	_this.menusObj[firstPId] = 1;
					// }
                    // if(item.level == '2' && _this.parentsObj[item.id]){
                    //     var firstPId = _this.parentsObj[item.id].firstParent;
                    //     _this.menusObj[firstPId] = 1;
                    // }
                    // if(item.level == '3' && _this.parentsObj[item.id]){
                    //     var firstPId = _this.parentsObj[item.id].firstParent;
                    //     var secondPId = _this.parentsObj[item.id].secondParent;
                    //     _this.menusObj[firstPId] = 1;
                    //     _this.menusObj[secondPId] = 1;
                    // }
                });

                _this.menus = [];
                for(var mId in  _this.menusObj){
                    if(mId!=='0')_this.menus.push(mId);
                }
            },
            //  菜单列表
            initMenuList() {
                // 所有的菜单列表
                var _this = this;
                var flag = -1;
                var url = this.$api.menu.list;
                 _this.$httpUtil.ajaxGet(this, url, this.$config.listAllPageParams, function(response) {
                     var dbList = response.data.data.content;
                        var sortList = dbList.sort(_this.$util.compare('sort'));

                        // 菜单对象
                        var menusObj = {};
                        _this.menus = [];
                        _this.menuList = [];

                        // sortList.forEach(item =>{
                        //     var p = {
                        //         title: item.menuNameZh,
                        //         id: item.id,
                        //         level: item.menuLevel,
                        //         parentId: item.parentId,
                        //         // expand: checked,
                        //         children: [],
                        //         checked: false
                        //     };
                        //     menusObj[item.id] = p;
                        // });
						//
                        // // 遍历菜单对象
                        // for(var menuId in menusObj){
                        //     var menuTemp = menusObj[menuId];
                        //     if(menuTemp.parentId !== '0'){
                        //         menusObj[menuTemp.parentId].children.push(menuTemp);
                        //     }
                        // }
						//
                        // _this.parentsObj = {};
                        // // 生成列表
                        // for(var menuId in menusObj){
						//
                        //     var temp = menusObj[menuId];
                        //     var checked = $.inArray(menuId, _this.defaultList) >= 0 ? true : false;
                        //     if (temp.children.length > 0) {
                        //         checked = false;
                        //     }
                        //     if (checked) {
                        //         _this.menus.push(menuId);
                        //     }
                        //     menusObj[menuId].checked = checked;
						//
						//
                        //     if(temp.level == '1'){
                        //         _this.menuList.push(temp);
                        //     }
						//
                        //     var cObj  = {};
                        //     if(temp.level == '2'){
                        //         cObj.firstParent = temp.parentId;
                        //     }
						//
                        //     if(temp.level == '3'){
                        //         cObj.secondParent = temp.parentId;
                        //         cObj.firstParent = menusObj[temp.parentId].parentId;
                        //     }
                        //     _this.parentsObj[menuId] = cObj;
                        // }


                        sortList.forEach((item, index) => {
                            var checked = $.inArray(item.id, _this.defaultList) >= 0 ? true : false;

                            if (item.menuLevel === 0) {
                                checked = false;
                                _this.menus.push(item.id);
                            }
                            if (checked) {
                                _this.menus.push(item.id);
                                _this.hasSel = true;
                            }


                             var p = {
								  title: item.menuNameZh,
								  id: item.id,
								  level: item.menuLevel,
								  parentId: item.parentId,
								  expand: checked,
								  children: [],
								  checked:checked
							  }
                            if (item.parentId === 0 || item.parentId === '0') {
                                flag++;
                                _this.menuList.push(p);
                            } else {
                                _this.menuList[flag].children.push(p);
                            }
                        });
                       // console.log(_this.menuList);
                });
            },
        },
        mounted() {
            this.init();
        },
        watch: {}
    };
</script>




// WEBPACK FOOTER //
// src/views/role/detail.vue